import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay-modal"
}
const _hoisted_2 = { class: "modal-adjuntos" }
const _hoisted_3 = { class: "modal-sub" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "seccion" }
const _hoisted_6 = { class: "seccion-titulo" }
const _hoisted_7 = {
  key: 0,
  class: "contador"
}
const _hoisted_8 = {
  key: 0,
  class: "vacio"
}
const _hoisted_9 = {
  key: 1,
  class: "vacio"
}
const _hoisted_10 = {
  key: 2,
  class: "lista-adjuntos"
}
const _hoisted_11 = { class: "item-info" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "item-meta" }
const _hoisted_14 = { class: "item-acciones" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "seccion" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "lista-seleccion"
}
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "item-meta" }
const _hoisted_24 = ["disabled", "onClick"]
const _hoisted_25 = { class: "botones" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]

import { ref, watch } from 'vue'
import type InformeAdjunto from '@/interfaces/InformeAdjunto'
import {
  listarInformesAdjuntosService,
  subirInformesAdjuntosService
} from '@/services/InformesAdjuntosService'
import MensajeFlotante from '@/components/MensajeFlotante.vue'

const ACEPTADOS = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.png,.jpg,.jpeg,.txt'
const MAX_BYTES = 20 * 1024 * 1024


export default /*@__PURE__*/_defineComponent({
  __name: 'AdjuntarInformesModal',
  props: {
    visible: { type: Boolean },
    idEjecucion: {},
    periodo: {}
  },
  emits: ["cerrar", "subido"],
  setup(__props: any, { emit: __emit }) {

/**
 * Adjuntar informes externos a una ejecución antigua.
 *
 * Solo se agregan y se consultan: por diseño no hay edición ni borrado.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

// Debe coincidir con las extensiones que valida el backend.
const adjuntos = ref<InformeAdjunto[]>([])
const seleccionados = ref<File[]>([])
const cargando = ref(false)
const subiendo = ref(false)
const inputArchivos = ref<HTMLInputElement | null>(null)
const mensajeVisible = ref(false)
const mensajeTexto   = ref('')
const mensajeTipo    = ref<'positivo' | 'error'>('positivo')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value   = texto
  mensajeTipo.value    = tipo
  mensajeVisible.value = true
}

watch(
  () => [props.visible, props.idEjecucion] as const,
  ([visible]) => {
    if (visible) {
      seleccionados.value = []
      mensajeVisible.value = false
      cargar()
    }
  },
  { immediate: true }
)

async function cargar() {
  if (!props.idEjecucion) return
  cargando.value = true
  try {
    adjuntos.value = await listarInformesAdjuntosService(props.idEjecucion)
  } finally {
    cargando.value = false
  }
}

function alSeleccionar(evento: Event) {
  const input = evento.target as HTMLInputElement
  const elegidos = Array.from(input.files ?? [])

  const pesados = elegidos.filter(f => f.size > MAX_BYTES)
  if (pesados.length) {
    mostrarMensaje(
      `Estos archivos superan el límite de 20 MB: ${pesados.map(f => f.name).join(', ')}`,
      'error'
    )
  }

  const validos = elegidos.filter(f => f.size <= MAX_BYTES)
  for (const f of validos) {
    const yaEsta = seleccionados.value.some(s => s.name === f.name && s.size === f.size)
    if (!yaEsta) seleccionados.value.push(f)
  }

  if (inputArchivos.value) inputArchivos.value.value = ''
}

function quitar(indice: number) {
  seleccionados.value.splice(indice, 1)
}

async function subir() {
  if (!props.idEjecucion || !seleccionados.value.length) return
  subiendo.value = true
  try {
    const res = await subirInformesAdjuntosService(props.idEjecucion, seleccionados.value)
    if (!res.ok) {
      mostrarMensaje(res.error ?? 'No se pudieron subir los archivos.', 'error')
      return
    }
    const cantidad = res.adjuntos?.length ?? seleccionados.value.length
    seleccionados.value = []
    await cargar()
    emit('subido', cantidad)
  } finally {
    subiendo.value = false
  }
}

function cerrar() {
  if (subiendo.value) return
  emit('cerrar')
}

function formatearTamano(bytes?: number | null): string {
  if (!bytes) return '—'
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

function formatearFecha(iso?: string | null): string {
  if (!iso) return ''
  const d = new Date(iso)
  return isNaN(d.getTime())
    ? ''
    : d.toLocaleDateString('es-CO', { year: 'numeric', month: 'short', day: 'numeric' })
}

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "modal-titulo" }, "Adjuntar informes", -1)),
          _createElementVNode("p", _hoisted_3, [
            _cache[1] || (_cache[1] = _createTextVNode(" Ejecución ")),
            _createElementVNode("strong", null, "#" + _toDisplayString(_ctx.idEjecucion), 1),
            (_ctx.periodo)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " · periodo " + _toDisplayString(_ctx.periodo), 1))
              : _createCommentVNode("", true)
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "nota" }, " Documentos que se generaron en su momento para esta autoevaluación. Una vez adjuntados no se pueden eliminar. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, [
              _cache[2] || (_cache[2] = _createTextVNode(" Archivos adjuntos ")),
              (adjuntos.value.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(adjuntos.value.length), 1))
                : _createCommentVNode("", true)
            ]),
            (cargando.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Cargando…"))
              : (!adjuntos.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Todavía no hay archivos adjuntos."))
                : (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adjuntos.value, (a) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: a.id_adjunto,
                        class: "item-adjunto"
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", {
                            class: "item-nombre",
                            title: a.nombre
                          }, _toDisplayString(a.nombre), 9, _hoisted_12),
                          _createElementVNode("span", _hoisted_13, [
                            _createTextVNode(_toDisplayString(formatearTamano(a.bytes)) + " ", 1),
                            (a.usuario?.name)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" · " + _toDisplayString(a.usuario.name), 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            (a.created_at)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(" · " + _toDisplayString(formatearFecha(a.created_at)), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("a", {
                            href: a.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "btn-ver"
                          }, "Ver", 8, _hoisted_15),
                          _createElementVNode("a", {
                            href: a.url_descarga || a.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "btn-descargar"
                          }, "Descargar", 8, _hoisted_16)
                        ])
                      ]))
                    }), 128))
                  ]))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "seccion-titulo" }, "Agregar archivos", -1)),
            _createElementVNode("label", {
              class: _normalizeClass(["dropzone", { deshabilitada: subiendo.value }])
            }, [
              _createElementVNode("input", {
                ref_key: "inputArchivos",
                ref: inputArchivos,
                type: "file",
                multiple: "",
                accept: ACEPTADOS,
                disabled: subiendo.value,
                class: "input-oculto",
                onChange: alSeleccionar
              }, null, 40, _hoisted_18),
              (!seleccionados.value.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Seleccionar archivos (PDF, Word, Excel, PowerPoint, imágenes) "))
                : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(seleccionados.value.length) + " archivo(s) seleccionado(s)", 1))
            ], 2),
            (seleccionados.value.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seleccionados.value, (f, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: i,
                      class: "item-seleccion"
                    }, [
                      _createElementVNode("span", {
                        class: "item-nombre",
                        title: f.name
                      }, _toDisplayString(f.name), 9, _hoisted_22),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(formatearTamano(f.size)), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-quitar",
                        disabled: subiendo.value,
                        title: "Quitar de la selección",
                        onClick: ($event: any) => (quitar(i))
                      }, "✕", 8, _hoisted_24)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              class: "btn salir",
              disabled: subiendo.value,
              onClick: cerrar
            }, "Cerrar", 8, _hoisted_26),
            _createElementVNode("button", {
              class: "btn guardar",
              disabled: subiendo.value || !seleccionados.value.length,
              onClick: subir
            }, _toDisplayString(subiendo.value ? 'Subiendo…' : `Subir ${seleccionados.value.length || ''}`.trim()), 9, _hoisted_27)
          ]),
          _createVNode(MensajeFlotante, {
            visible: mensajeVisible.value,
            mensaje: mensajeTexto.value,
            tipo: mensajeTipo.value,
            onCerrar: _cache[0] || (_cache[0] = ($event: any) => (mensajeVisible.value = false))
          }, null, 8, ["visible", "mensaje", "tipo"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})